(function(angular) {
  'use strict';

  var app = angular.module('asSupplyMgr');

  app.controller('ItemEditController', [
    '$scope',
    '$window',
    'itemsApi',
    '$q',
    function($scope, $window, itemsApi, $q) {
      // init values
      $scope.item = {
        name: '',
        type: '',
        active: 1,
        source_ref: '',
        min_cpm: '',
        max_cpm: '',
        handicap: '0',
        hard_properties: '',
        overwrite_idomain: '',
        properties: {
          deal_filter: [],
          dvt: [],
          creative_types_group: '',
          do_not_log: 0,
          is_sspx_enabled: 0
        },
        iab_categories: ['IAB24'],
        iab_tcf_strict_level_id: 1,
        ablocker: '0',
      };

        $scope.log = {
            count: 0,
            data: [],
        };

        $scope.default_vast_properties = [
            "nomidroll"
        ];

      $scope.devices = [
        { name: 'Smartphone', value: 'smartphone' },
        { name: 'Tablet', value: 'tablet' },
        { name: 'Desktop', value: 'desktop' },
        { name: 'TV', value: 'tv' },
      ];

      $scope.handicaps = [
          {name: '0%', value: '0'},
          {name: '-5%', value: '5'},
          {name: '-10%', value: '10'},
          {name: '-20%', value: '20'},
          {name: '-30%', value: '30'},
          {name: '-40%', value: '40'},
          {name: '-50%', value: '50'},
          {name: '-60%', value: '60'},
          {name: '-70%', value: '70'},
          {name: '-80%', value: '80'},
          {name: '-90%', value: '90'},
          {name: '-95%', value: '95'},
          {name: '-100%', value: '100'}
      ];

      $scope.ablocker_options = [
          {name: 'ignore', value: '-1'},
          {name: 'default', value: '0'},
          {name: 'soft', value: '1'},
          {name: 'medium', value: '5'},
          {name: 'hard', value: '10'},
      ];

      $scope.types = [];
      $scope.sources = [];
      $scope.deals = [];
      $scope.creativeTypes = [];
      $scope.iabCategories = [];

      $scope.infoTable = null;


      var getTypes = itemsApi.getTypes();
      getTypes.then(types => {
        $scope.types = [];

        Object.keys(types).forEach(key => {
          $scope.types.push({
            name: types[key],
            value: key,
          });
        });
      });


    $scope.vast_properties = {};
    $scope.$watch('vast_properties', function(newVal, oldVal) {
        console.log($scope.vast_properties);
        if (newVal && oldVal && newVal !== oldVal) {
            $scope.item['vast_properties'] = [];
            Object.keys($scope.vast_properties).forEach(key => {
                if ($scope.vast_properties[key] === 1) {
                    $scope.item['vast_properties'].push(key);
                }
            });
            if (typeof $scope.vast_properties.invpartner_domain !== 'undefined') {
                $scope.item['vast_properties'].push({invpartner_domain: $scope.vast_properties.invpartner_domain});
            }
        }
    }, true);
    $scope.hasVastProperties = false;
    $scope.hasVastPropertiesCTV = false;
    $scope.$watch('item.properties.creative_types_group', function(newVal, oldVal) {
        if (newVal && oldVal && newVal !== oldVal) {
            let types = $scope.item.properties.creative_types_group;
            $scope.hasVastPropertiesCTV =  types.includes("vastInlineCtv");
            if (!$scope.hasVastPropertiesCTV) {
                delete $scope.item['app_details'];
            }
            $scope.hasVastProperties = (types.includes("vastInlineHtml") && types.includes("vastInlineHtmlWrapper")) || $scope.hasVastPropertiesCTV;
            if ($scope.hasVastProperties) {
                if ($scope.item['vast_properties'] === undefined) {
                    $scope.item['vast_properties'] = $scope.default_vast_properties;
                }
                $scope.vast_properties = $scope.item['vast_properties'].reduce(function (obj, itm) {
                    if (typeof itm === 'object') {
                        Object.keys(itm).forEach(function(r){obj[r] = itm[r];});
                    } else {
                        obj[itm] = 1;
                    }
                    return obj;
                }, {});
            } else {
                delete $scope.item['vast_properties'];
            }
        }
    }, true);




        var getSources = itemsApi.getSources();
      getSources.then(sources => {
        $scope.sources = [];

        Object.keys(sources).forEach(key => {
          $scope.sources.push({
            name: sources[key].name,
            value: key,
          });
        });
        $scope.sources.sort(function(a, b) {
            return a.name.localeCompare(b.name);
        });
      });

      var getDeals = itemsApi.getDeals();
      getDeals.then(deals => {
        $scope.deals = [];

        Object.keys(deals).forEach(key => {
          $scope.deals.push({
            name: deals[key].name,
            value: key,
          });
        });
      });

      var getDevices = itemsApi.getDevices();
      getDevices.then(devices => {
        $scope.devices = [];

        Object.keys(devices).forEach(key => {
          $scope.devices.push({
            name: devices[key],
            value: key,
          });
        });
      });

      var getCreatives = itemsApi.getCreatives();
      getCreatives.then(creativeTypes => {
        $scope.creativeTypes = [];

        creativeTypes.forEach(t => {
          $scope.creativeTypes.push({
            name: t,
            value: t,
          });
        });
      });

        var getIabCategories = itemsApi.getIabCategories(false, true, true);
        getIabCategories.then(iabCategoriesList => {
            $scope.iabCategories = iabCategoriesList;
        });

        var getIabTcfStrictLevels = itemsApi.getIabTcfStrictLevels();
        getIabTcfStrictLevels.then(iabTcfStrictLevels => {
            $scope.iabTcfStrictLevels = iabTcfStrictLevels;
        });

      // load item from server
      if ($window.itemId) {
         // $q.all([getTypes,getSources,getDeals,getDevices, getCreatives]).then(function(){
                      itemsApi.read($window.itemId).then(
                          data => {
                            $scope.item = data.item;
                            $scope.log = data.log;
                          },
                      () => {
                          console.error('could not load item');
                      });
         //     });
      }

      // try saving and process server side validation errors
      $scope.submitForm = () => {
        itemsApi.save($scope.item).then(
          () => {
            $window.location.href = '/#!/supply/inventory/items';
          },
            data => {
                defaultSaveErrorHandler($scope.itemForm, data);
            }
        );
      };
    },
  ]);
})(window.angular);

/**
 * List Controller
 */
(function(angular) {
  'use strict';

  let app = angular.module('asSupplyMgr');

  app.controller('ItemsIndexController', [
    '$scope',
    'itemsApi',
    function($scope, itemsApi) {
      // select search input content on focus
      $('#search').click(function() {
        $(this).select();
      });

      $scope.loading = false;

      $scope.list = null;

      $scope.sourceFilter = [-1];
      $scope.inventoryTypeFilter = [-1];

      $scope.csvItemsColumns = csvItemColumns;
      $scope.csvExportColumns = csvItemColumns.map(function(k){
          return k.value;
      });



      $scope.statusFilter = ['running','paused'];
      $scope.$watch('statusFilter', function(newVal, oldVal) {
            if (newVal && oldVal && newVal !== oldVal) {
                $scope.fetch();
            }
      }, true);

      $scope.page = {
        number: 0,
        size: 500,
      };

      $scope.searchTerm = '';

      $scope.sort = {
        field: 'id',
        order: 'desc',
      };

      $scope.sources = [];

      $scope.inventoryTypes = [];

      /**
       * If user presses enter in search box perform the search
       * @param e
       */
      $scope.checkSubmit = function(e) {
        if (e.originalEvent.charCode === 13) {
          $scope.search();
        }
      };

      $scope.search = function() {
        $scope.page.number = 0;

        $scope.fetch();
      };

      var getSources = itemsApi.getSources(true);
      getSources.then(sources => {
            $scope.sources = [];
            Object.keys(sources).forEach(key => {
                $scope.sources.push({name: sources[key].name,value: key});
            });
          $scope.sources.sort(function(a, b) {
              return a.name.localeCompare(b.name);
          });
          $scope.sourceFilter = Object.keys(sources);
            $scope.$watch('sourceFilter', function(newVal, oldVal) {
                if (newVal && oldVal && newVal !== oldVal) {
                    $scope.fetch();
                }
            }, true);
    });


        var getCreatives = itemsApi.getCreatives();
        getCreatives.then(creativeTypes => {
            $scope.creativeTypes = [];

            creativeTypes.forEach(t => {
                $scope.creativeTypes.push({
                    name: t,
                    value: t,
                });
            });
        });
        var getInventoryTypes= itemsApi.getCreatives();
        getInventoryTypes.then(types => {
            $scope.inventoryTypes = [];
            types.forEach(t => {
                $scope.inventoryTypes.push({
                    name: t,
                    value: t,
                });
            });

            $scope.inventoryTypeFilter = types;
            $scope.$watch('inventoryTypeFilter', function(newVal, oldVal) {
                if (newVal && oldVal && newVal !== oldVal) {
                    $scope.fetch();
                }
            }, true);
        });

      /**
       * Fetch list data from server
       */
      $scope.fetch = function() {
        $scope.loading = true;

        let sourceFilterFetchArray = $scope.sourceFilter.length == $scope.sources.length ? [-1] : $scope.sourceFilter;
        let inventoryTypesFilterArray = $scope.inventoryTypeFilter.length == $scope.inventoryTypes.length ? [-1] : $scope.inventoryTypeFilter;

        itemsApi.getList($scope.sort, $scope.searchTerm, $scope.page, $scope.statusFilter, sourceFilterFetchArray, inventoryTypesFilterArray).then(
          function(data) {
            $scope.list = {
              count: data.count,
              data: data.data,
              maxPage: Math.ceil(data.count / $scope.page.size),
            };
            $scope.loading = false;
          },
          function() {
            $scope.list = {
              count: 0,
              data: [],
              maxPage: null,
            };
            $scope.loading = false;
          }
        );
      };

      /**
       * set page to new value and load data
       * @param page
       */
      $scope.setPage = function(page) {
        $scope.page.number = page;

        $scope.fetch();
      };

      /**
       * get the sort css for a given column
       * @param field
       * @returns {*}
       */
      $scope.getSortCssClass = function(field) {
        if ($scope.sort.field === field) {
          return 'fa-sort-' + $scope.sort.order;
        } else {
          return 'fa-sort';
        }
      };

      /**
       * update sorting and fetch data
       * @param field
       */
      $scope.setSort = function(field) {
        $scope.page.number = 0;

        if ($scope.sort.field === field) {
          $scope.sort.order = $scope.sort.order === 'desc' ? 'asc' : 'desc';
        } else {
          $scope.sort.field = field;
          $scope.sort.order = 'desc';
        }

        $scope.fetch();
      };

      $scope.changeState = function(item) {
        let id = item.id;
        let newState = item.active === 'Active' ? 0 : 1;
        itemsApi.changeState(id, newState).then(function() {
          $scope.fetch();
        });
      };



        /**
         * show the duplicate confirmation dialog
         * @param item
         */
        $scope.promptDuplicate = function(item) {
            $scope.itemToDuplicate = item;
            $('#duplicate-modal').modal('show');
        };

        /**
         * show the info dialog
         * @param item
         */
        $scope.showInfo = function (item) {
            $scope.itemToInfo = item;
            var url = "/supply/inventory/items/info?id=" + item.id;
            if (!$scope.infoTable) {
                $scope.infoTable = $('#info-table').DataTable({
                    serverSide: true,
                    processing: true,
                    ajax: url,
                    scrollY: "200px",
                    scrollCollapse: true,
                    paging: false,
                    searching: false,
                    info: false,
                    bInfo: false,
                    orderMulti: true,
                    order: [[0, "asc"], [1, "desc"], [2, 'desc']],
                    columns: [
                        {
                            name: 'status',
                            render: function(data, type, row){
                                switch (data){
                                    case 0:
                                        return 'Inactive';
                                    case 1:
                                        return 'Active';
                                    default:
                                        return 'Unknown';
                                }
                            },
                            orderable: true
                        },
                        {name: 'prio',orderable: true},
                        {name: 'cid', orderable: true},
                        {
                            name: 'cname',
                            render: function ( data, type, row ) {
                                return "<a " + (row[6]?'':'class="cantDelivered"') +" href='/#!/demandmgr/campaign/edit?id="+row[2]+"' target='_blank'>"+data+"</a> " + "(" + row[7] + ")";
                            },
                            orderable: false
                        },
                        {
                            name: 'creative',
                            orderable: false,
                            render: function ( data, type, row ) {
                                return "<a " + (row[6]?'':'class="cantDelivered"') +" href='/#!/demandmgr/creative/edit?creative="+row[5]+"&campaignid="+row[2]+"' target='_blank'>"+data+"</a>";
                            }
                        }

                    ]
                });
            } else {
                $scope.infoTable.ajax.url(url).load(function (res) {
                    console.log('Info loaded');
                });
            }

            $('#info-modal').modal('show').on('shown.bs.modal', function (e) {
                    //$('#info-table').css('display','block');
                    $('#info-table').DataTable().columns.adjust().responsive.recalc();
                }
            );


        }


        /**
         * duplicate an item item
         * @param item
         */
        $scope.duplicate = function(item) {
            itemsApi.duplicate(item.id).then(function() {
                $scope.fetch();
            });
        };


      /**
       * show the delete confirmation dialog
       * @param item
       */
      $scope.promptDelete = function(item) {
        $scope.itemToDelete = item;
        $('#delete-modal').modal('show');
      };

      /**
       * delete an item item
       * @param item
       */
      $scope.delete = function(item) {
        itemsApi.delete(item.id).then(function() {
          $scope.fetch();
        });
      };

      /**
       * export list to csv
       */
      $scope.export = function() {
        var statusFilterFetchArray = $scope.sourceFilter.length == $scope.sources.length ? [-1] : $scope.sourceFilter;

        var url = '/supply/inventory/items/export' +
                  getReportUrl($scope.sort, $scope.searchTerm, {'status': $scope.statusFilter, 'sources': statusFilterFetchArray});

        window.location.href = url;
      };

        /**
         * export list to csv
         */
      $scope.exportRaw = function(isRequestNow) {
          if (isRequestNow) {
              var url = '/supply/inventory/items/exportRaw?columns=' + $scope.csvExportColumns;
              window.location.href = url;
          } else {
              $('#exportraw-modal').modal('show');
          }
      };

      $scope.fetch();
    },
  ]);
})(window.angular);
